import setCurrentPage from "src/Utils/setCurrentPage";
import UseCaseVideoPanel from "src/Components/Common/UseCaseVideoPanel";
import setPreviousPage from "src/Utils/setPreviousPage";

const LIST_DATA_USE_CASE_3 = [
  {
    icon: "graphWithDollarSign",
    iconColor: "white",
    text: `<b>$21 million</b> of \nsavings reached`,
    listItemCustomStyle: { width: "204px" },
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
  {
    icon: "computerWithPaper",
    iconColor: "white",
    text: `<b>700K+</b> mobile tower \nlease contracts proceed`,
    listItemCustomStyle: { width: "294px" },
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
  {
    icon: "peopleWithCircuitsInsideCircle",
    iconColor: "white",
    text: `<b>60% </b>improvement in \nemployee productivity`,
    listItemCustomStyle: { width: "243px" },
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
];

const DATA_EV_DEMO_USE_CASE_3 = {
  headerRightText: "GET THE EDGE",
  headerLeftImage: "EdgeverveLogo.png",
  title: "TOWER LEASE CONTRACTS",
  titleStyle: {
    marginTop: "-32px",
    fontSize: "100px",
    textTransform: "uppercase",
  },
  subtitle: "Use case 2",
  subtitleStyle: { color: "#92D1FF", fontSize: "24px", marginTop: "32px" },
  text: "Achieve unparalleled business outcomes with \nenhanced negotiations, insights, and a clear view of \nyour contracts and hidden risks.",
  textStyle: { marginTop: "60px", marginBottom: "40px" },
  listData: LIST_DATA_USE_CASE_3,
  back: {
    label: "BACK",
    onClick: () => setCurrentPage(403),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "EV/EV_demo_Intro_06.png",
  rightSideComponent: (
    <UseCaseVideoPanel
      infoIconClick={() => {
        setPreviousPage(410);
        setCurrentPage(419);
      }}
      imageClick={() => setCurrentPage(411)}
      title="WATCH THE EXPLAINER VIDEO"
      image="EV/EV_demo_use_case_03.png"
      bottomButtons={[
        {
          label: "DEMO VIDEO",
          onClick: () => setCurrentPage(412),
          endIcon: "play",
        },
      ]}
    />
  ),
};

export default DATA_EV_DEMO_USE_CASE_3;
